"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSectionFlexBasisStyles = void 0;
const sizeToString_1 = require("./sizeToString");
const getSectionFlexBasisStyles = ({ size, modelValue, isColumnDirection, hasDefaultFlexBasisStyle }) => {
    var _a, _b;
    if (modelValue === null || modelValue === void 0 ? void 0 : modelValue.shouldApply) {
        return (0, sizeToString_1.sizeToString)(isColumnDirection ? (_a = modelValue === null || modelValue === void 0 ? void 0 : modelValue.height) !== null && _a !== void 0 ? _a : 0 : (_b = modelValue === null || modelValue === void 0 ? void 0 : modelValue.width) !== null && _b !== void 0 ? _b : 0);
    }
    const result = (0, sizeToString_1.sizeToString)(size);
    if (result !== undefined) {
        return result;
    }
    return hasDefaultFlexBasisStyle ? '50%' : undefined;
};
exports.getSectionFlexBasisStyles = getSectionFlexBasisStyles;
//# sourceMappingURL=getSectionFlexBasisStyles.js.map